/**
 * @param {Number } type 1：提示 2：警告  3：错误 4 ：成功
 * @param {String }msg  展示信息
 * @param {String}self this
 * @param
 */
export function showWindowMessage(type, msg, self) {
  if (!msg) {
    return;
  }
  switch (type) {
    case 1:
      self.$notify.info({
        title: "提示",
        message: msg,
        customClass: "messageInfo",
        duration: 4000
      });
      break;
    case 2:
      self.$notify({
        type: "warning",
        title: "警告",
        message: msg,
        customClass: "messageWarn",
        duration: 4000
      });
      break;
    case 3:
      self.$notify.error({
        title: "错误",
        type: "error",
        message: msg,
        customClass: "messageError",
        duration: 4000
      });
      break;
    case 4:
      self.$notify({
        type: "success",
        title: "提示",
        customClass: "messageSuccess",
        message: msg,
        duration: 5000
      });
      break;
    default:
      break;
  }
}
